module.exports = __webpack_public_path__ + "static/media/menu.a8a4f842.svg";